import React from 'react';

import previewImage from './LoadingIcon.gif';

export default function LoadingIcon(props) {
  return <img src={[previewImage]} alt='' />;
}
